console.log("from customjs file")

 // Drag and move functionality
  document.addEventListener("DOMContentLoaded", function() {
    const draggableGrid = document.querySelector(".js-draggable-grid");

    draggableGrid.addEventListener("dragstart", function(event) {
      event.dataTransfer.setData("text/plain", "");
      event.currentTarget.classList.add("dragging");
    });

    draggableGrid.addEventListener("dragend", function(event) {
      event.currentTarget.classList.remove("dragging");
    });

    draggableGrid.addEventListener("dragover", function(event) {
      event.preventDefault();
      const draggingElement = document.querySelector(".dragging");
      const boundingRect = draggingElement.getBoundingClientRect();
      const offsetY = event.clientY - boundingRect.height / 2;
      draggingElement.style.transform = `translateY(${offsetY}px)`;
    });

    draggableGrid.addEventListener("drop", function(event) {
      event.preventDefault();
      const draggingElement = document.querySelector(".dragging");
      const droppedElement = event.target.closest(".grid-product");
      if (draggingElement && droppedElement) {
        const droppedIndex = Array.from(draggableGrid.children).indexOf(droppedElement);
        const draggingIndex = Array.from(draggableGrid.children).indexOf(draggingElement);
        if (draggingIndex < droppedIndex) {
          draggableGrid.insertBefore(draggingElement, droppedElement.nextSibling);
        } else {
          draggableGrid.insertBefore(draggingElement, droppedElement);
        }
      }
    });
  });